export default __webpack_public_path__ + "static/media/7.e47a23e6.jpg";